// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"2410a54f","652":"7be9adf0"}[chunkId] + ".chunk.css";
};